import { useClientStore } from "@/store/client";
import type { CalendarType } from "@/lib/date_time/formatter";

export function useClientIndicatorCalendarType(): CalendarType {
  const clientStore = useClientStore();
  return clientStore.config?.kpiCalendar ?? "gregorian";
}
